/**
 * call-transcript — the single "what belongs to this call's transcript"
 * selection, shared by transcript-rail.tsx (renders it) and orb-docking.ts
 * (needs to know whether it's non-empty yet to decide docking — see that
 * file). Extracted out of transcript-rail.tsx (FB35/Turn 17) so the two
 * consumers can't drift on what counts as "this call's" content: before
 * this split, transcript-rail.tsx had the only copy of this filter and
 * orb-docking.ts would otherwise have had to re-derive it.
 *
 * Pure (no React, no DOM) — messages/startIndex in, a filtered array out.
 */

import { MessageRole, type Message } from '@/types/chat';

/**
 * "This call's" transcript: messages sent/said since `startIndex` (the
 * value of ChatContext's `callStartMessageIndexRef` at call start),
 * narrowed to the two spoken roles, non-empty, and never a tool-result card
 * (find_courses/RAG cards don't belong in a live-captions rail). Sara's
 * in-flight turn is included — voice streaming upserts straight into
 * `messages` via appendAssistantDelta, so a still-streaming turn is just a
 * `Message` with `streaming: true`, already covered by this filter.
 */
export function selectCallWindowMessages(
  messages: Message[],
  startIndex: number
): Message[] {
  return messages
    .slice(startIndex)
    .filter(
      (m) =>
        (m.role === MessageRole.USER || m.role === MessageRole.ASSISTANT) &&
        typeof m.content === 'string' &&
        m.content.trim().length > 0 &&
        !m.result
    );
}
